import { getShortUrlFlowSession } from "@/modules/tracking/utils/shortUrlFlowSession";
import { trackBookingEvent } from "@/modules/tracking/utils/trackBookingEvent";

export function trackShortUrlEvent(
  eventName: string,
  properties: Record<string, unknown> = {},
): void {
  const session = getShortUrlFlowSession();

  const correlationFromSession =
    "correlation_id" in properties
      ? properties.correlation_id
      : (session?.correlationId ?? null);

  trackBookingEvent(eventName, {
    ...properties,
    correlation_id: correlationFromSession,
  });
}
